import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export default function ProtectedRoute({ children }) {
     const { session, loading } = useAuth();

     if (loading) {
          return (
               <div className='min-h-screen bg-black flex items-center justify-center'>
                    <p className='text-white/60'>Loading...</p>
               </div>
          );
     }

     if (!session) {
          return <Navigate to='/admin/login' replace />;
     }

     return children;
}
